module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/contents/noimage_s150x150-5e80f4784c7fa5f0b84e2ad428327cec.png";